/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} clickEditContentRceParams
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
* @property {string} origin - rce_panel / gfpp
**/
/**
 * Name: Click Edit Content RCE. Evid: 40.
 * Event description: user click on edit content inside the panel of RCE
 in the editor.

 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 *
 * origin - Type: string. Desc: rce_panel / gfpp
 * @param {clickEditContentRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickEditContentRce = function (params) {
    return { evid: 40, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} addPluginLinkParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} params - params will arrive according to the plugin
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Add Plugin link. Evid: 26.
 * Event description: each time user add link to the plugin.
the params will arrive according to the plugin
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * params - Type: string. Desc: params will arrive according to the plugin
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {addPluginLinkParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPluginLink = function (params) {
    return { evid: 26, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} addContentToPluginParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} source - the place the content add for example in a (table:cell, poll: answer/question)
* @property {string} type - plugin/text
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Add Content To Plugin. Evid: 27.
 * Event description: each time user add content to plugin
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * source - Type: string. Desc: the place the content add for example in a (table:cell, poll: answer/question)
 *
 * type - Type: string. Desc: plugin/text
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {addContentToPluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addContentToPlugin = function (params) {
    return { evid: 27, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} clickToolbarButtonParams
* @property {string} buttonName - bold/underline/italian etc.
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Click toolbar button. Evid: 45.
 * Event description: User clicks one of the buttons in the formatting toolbar.

 * buttonName - Type: string. Desc: bold/underline/italian etc.
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {clickToolbarButtonParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickToolbarButton = function (params) {
    return { evid: 45, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} addAnswerToAPollParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Add Answer To a Poll. Evid: 29.
 * Event description: each time user click add answer in poll
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {addAnswerToAPollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addAnswerToAPoll = function (params) {
    return { evid: 29, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} tablePluginDeleteColumnRowParams
* @property {string} category - column/row
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - the post id from the consumer
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: table plugin delete column/row. Evid: 21.
 * Event description: each time column or row delete from a table plugin.

 * category - Type: string. Desc: column/row
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: the post id from the consumer
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {tablePluginDeleteColumnRowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tablePluginDeleteColumnRow = function (params) {
    return { evid: 21, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} panelNavigateRceParams
* @property {string} category - main/design/settings/support
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
**/
/**
 * Name: Panel Navigate RCE. Evid: 38.
 * Event description: user navigate inside the panel of RCE in the editor.

 * category - Type: string. Desc: main/design/settings/support
 *
 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 * @param {panelNavigateRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelNavigateRce = function (params) {
    return { evid: 38, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} searchInsideThePluginParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugin_specification - bookings/stores/events
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} searchTerm - the word the user search for
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Search inside the plugin. Evid: 34.
 * Event description: when user search inside plugin.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugin_specification - Type: string. Desc: bookings/stores/events
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * searchTerm - Type: string. Desc: the word the user search for
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {searchInsideThePluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchInsideThePlugin = function (params) {
    return { evid: 34, src: 116, endpoint: 'rich-editor', params: params };
};
/*event 1 on project 'com.wixpress.rich-editor' has no function name set, please set one in BI Catalog.*/
/**
* @typedef {Object} panelDisplayNavigateRceParams
* @property {string} category - null
* @property {string} component_id - unique id of the component
* @property {string} content_id - unique id of the post
* @property {string} selection - null
* @property {string} subcategory - background/texts/button and links
* @property {string} value - value of the field
**/
/**
 * Name: Panel Display Navigate RCE. Evid: 52.
 * Event description: user navigate inside the Display panel of RCE in the editor.

 * category - Type: string.
 *
 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string. Desc: unique id of the post
 *
 * selection - Type: string.
 *
 * subcategory - Type: string. Desc: background/texts/button and links
 *
 * value - Type: string. Desc: value of the field
 * @param {panelDisplayNavigateRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelDisplayNavigateRce = function (params) {
    return { evid: 52, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} deleteAnswerFromPollParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - null
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Delete Answer From Poll. Evid: 30.
 * Event description: each time user click delete answer in poll
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string.
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {deleteAnswerFromPollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteAnswerFromPoll = function (params) {
    return { evid: 30, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} keyboardShortcutActionParams
* @property {string} button_name - the name of the button user clicked on
* @property {string} category - category of change (alignment/size/settings...)
* @property {string} container - blog/groups...
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} origin - toolbar/sidebar/ else
* @property {string} plugin_id - plugin
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
* @property {string} type - toolbar type (plugin toolbar/ format toolbar)
* @property {string} value - value changed to (center, right...)
* @property {string} version - version . of rce
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Keyboard Shortcut Action. Evid: 47.
 * Event description: user changed plugin setting by a keyboard shortcut action.

 * button_name - Type: string. Desc: the name of the button user clicked on
 *
 * category - Type: string. Desc: category of change (alignment/size/settings...)
 *
 * container - Type: string. Desc: blog/groups...
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * origin - Type: string. Desc: toolbar/sidebar/ else
 *
 * plugin_id - Type: string. Desc: plugin
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * settingSessionId - Type: string. Desc: id of the setting session (each time the settings modal he will get a new one)
 *
 * type - Type: string. Desc: toolbar type (plugin toolbar/ format toolbar)
 *
 * value - Type: string. Desc: value changed to (center, right...)
 *
 * version - Type: string. Desc: version . of rce
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {keyboardShortcutActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var keyboardShortcutAction = function (params) {
    return { evid: 47, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} replaceImageInAPollParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} type - Answers/Question
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Replace Image In a Poll. Evid: 28.
 * Event description: each time user click on replace an image in poll
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * type - Type: string. Desc: Answers/Question
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {replaceImageInAPollParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var replaceImageInAPoll = function (params) {
    return { evid: 28, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} replacePluginParams
* @property {string} container - consumer name
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: replace plugin. Evid: 19.
 * Event description: in case of user replace the content of the plugin (replace picture/gip/ etc).

 * container - Type: string. Desc: consumer name
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {replacePluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var replacePlugin = function (params) {
    return { evid: 19, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginsPopoverTabSwitchParams
* @property {string} button_name - the name of the button user clicked on
* @property {string} category - category of change (alignment/size/settings...)
* @property {string} container - blog/groups...
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - Post ID
* @property {string} origin - toolbar/sidebar/ else
* @property {string} plugin_id - plugin
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
* @property {string} type - toolbar type (plugin toolbar/ format toolbar)
* @property {string} value - value changed to (center, right...)
* @property {string} version - version . of rce
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugins Popover Tab Switch. Evid: 51.
 * Event description: Tab switches in Plugins Popover.

 * button_name - Type: string. Desc: the name of the button user clicked on
 *
 * category - Type: string. Desc: category of change (alignment/size/settings...)
 *
 * container - Type: string. Desc: blog/groups...
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: Post ID
 *
 * origin - Type: string. Desc: toolbar/sidebar/ else
 *
 * plugin_id - Type: string. Desc: plugin
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * settingSessionId - Type: string. Desc: id of the setting session (each time the settings modal he will get a new one)
 *
 * type - Type: string. Desc: toolbar type (plugin toolbar/ format toolbar)
 *
 * value - Type: string. Desc: value changed to (center, right...)
 *
 * version - Type: string. Desc: version . of rce
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginsPopoverTabSwitchParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginsPopoverTabSwitch = function (params) {
    return { evid: 51, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} panelDesignNavigateRceParams
* @property {string} category - main/design/settings/support
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
* @property {string} subcategory - background/texts/button and links
**/
/**
 * Name: Panel Design Navigate RCE. Evid: 39.
 * Event description: user navigate inside the Design panel of RCE
 in the editor.

 * category - Type: string. Desc: main/design/settings/support
 *
 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 *
 * subcategory - Type: string. Desc: background/texts/button and links
 * @param {panelDesignNavigateRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var panelDesignNavigateRce = function (params) {
    return { evid: 39, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} settingsModalClosedForPluginParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} outcome - save/close
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Settings modal closed for plugin. Evid: 37.
 * Event description: each time the user closed the settings modal for plugin.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * outcome - Type: string. Desc: save/close
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * settingSessionId - Type: string. Desc: id of the setting session (each time the settings modal he will get a new one)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {settingsModalClosedForPluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsModalClosedForPlugin = function (params) {
    return { evid: 37, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} searchForPluginParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} searchTerm - the word the user search for
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Search for plugin. Evid: 35.
 * Event description: when user search for plugin.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * searchTerm - Type: string. Desc: the word the user search for
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {searchForPluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var searchForPlugin = function (params) {
    return { evid: 35, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} changePluginSettingsParams
* @property {string} actionName - action name
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} layout - in case there is then plugin layout
* @property {string} params - params will arrive according to the plugin
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} value - action value
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Change Plugin Settings. Evid: 25.
 * Event description: each time user change plugin settings
the params will arrive according to the plugin
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * actionName - Type: string. Desc: action name
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * layout - Type: string. Desc: in case there is then plugin layout
 *
 * params - Type: string. Desc: params will arrive according to the plugin
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * value - Type: string. Desc: action value
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {changePluginSettingsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changePluginSettings = function (params) {
    return { evid: 25, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} menuLoadParams
* @property {string} container - consumer name
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - external content id (based on usage)
* @property {string} menu - more, + side menu
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - (on refresh)
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Menu Load. Evid: 17.
 * Event description: Event for loading a menu (+, more, etc.).

 * container - Type: string. Desc: consumer name
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: external content id (based on usage)
 *
 * menu - Type: string. Desc: more, + side menu
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: (on refresh)
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {menuLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var menuLoad = function (params) {
    return { evid: 17, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} tablePluginClickActionFromOptionMenuParams
* @property {string} actionName - clear/merge cells / distribute rows / split cells
* @property {string} category - table/column/row
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - the post id from the consumer
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: table plugin click action from option menu. Evid: 23.
 * Event description: arrived each time user click on an action in 3 dots menu.

 * actionName - Type: string. Desc: clear/merge cells / distribute rows / split cells
 *
 * category - Type: string. Desc: table/column/row
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: the post id from the consumer
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {tablePluginClickActionFromOptionMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tablePluginClickActionFromOptionMenu = function (params) {
    return { evid: 23, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} addPluginParams
* @property {string} button_name - Specify button name
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} editor_engine - draft/tiptap
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugin_specification - bookings/stores/events etc.
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} search_term - in case the user search for the plugin the search term
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: add plugin click. Evid: 2.
 * Event description: user clicked add on a plug in.

 * button_name - Type: string. Desc: Specify button name
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugin_specification - Type: string. Desc: bookings/stores/events etc.
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * search_term - Type: string. Desc: in case the user search for the plugin the search term
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {addPluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPlugin = function (params) {
    return { evid: 2, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} clickOnPreviewRceParams
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
* @property {string} value - True/False
**/
/**
 * Name: Click On Preview RCE. Evid: 43.
 * Event description: user click on preview inside the panel of RCE in the editor.

 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 *
 * value - Type: string. Desc: True/False
 * @param {clickOnPreviewRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickOnPreviewRce = function (params) {
    return { evid: 43, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} clickExtensionButtonInToolbarParams
* @property {string} buttonType - formatting/plugin
* @property {string} button_type - formatting/plugin
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} toolbarType - initial features presented (formatting/plugin)
* @property {string} toolbar_type - null
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Click extension button in toolbar. Evid: 44.
 * Event description: user clicked the extension button in the formatting/plugin toolbar.

 * buttonType - Type: string. Desc: formatting/plugin
 *
 * button_type - Type: string. Desc: formatting/plugin
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * toolbarType - Type: string. Desc: initial features presented (formatting/plugin)
 *
 * toolbar_type - Type: string.
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {clickExtensionButtonInToolbarParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickExtensionButtonInToolbar = function (params) {
    return { evid: 44, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} deleteContentInPluginParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} source - the place the content add for example in a (table:cell, poll: answer/question)
* @property {string} type - plugin/text
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Delete Content In Plugin. Evid: 31.
 * Event description: each time user delete content in plugin
link to slides https://docs.google.com/presentation/d/12LnMS02yZEc5N4lV-SM5_HpOUEIRVzXkrFxDaENyl0o/edit#slide=id.p.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * source - Type: string. Desc: the place the content add for example in a (table:cell, poll: answer/question)
 *
 * type - Type: string. Desc: plugin/text
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {deleteContentInPluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deleteContentInPlugin = function (params) {
    return { evid: 31, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginsPopoverClickParams
* @property {string} button_name - null
* @property {string} category - category of change (alignment/size/settings...)
* @property {string} container - blog/groups...
* @property {string} container_id - null
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} origin - toolbar/sidebar/ else
* @property {string} plugin_id - plugin
* @property {string} pluginUniqueId - null
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - null
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} settingSessionId - null
* @property {string} type - toolbar type (plugin toolbar/ format toolbar)
* @property {string} value - value changed to (center, right...)
* @property {string} version - version . of rce
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugins Popover Click. Evid: 50.


 * button_name - Type: string.
 *
 * category - Type: string. Desc: category of change (alignment/size/settings...)
 *
 * container - Type: string. Desc: blog/groups...
 *
 * container_id - Type: string.
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * origin - Type: string. Desc: toolbar/sidebar/ else
 *
 * plugin_id - Type: string. Desc: plugin
 *
 * pluginUniqueId - Type: string.
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string.
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * settingSessionId - Type: string.
 *
 * type - Type: string. Desc: toolbar type (plugin toolbar/ format toolbar)
 *
 * value - Type: string. Desc: value changed to (center, right...)
 *
 * version - Type: string. Desc: version . of rce
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginsPopoverClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginsPopoverClick = function (params) {
    return { evid: 50, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginAttributesChangedParams
* @property {string} attribute - attribute name
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - Content_id
* @property {string} editor_engine - draft/tiptap
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} value - action value
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugin Attributes Changed. Evid: 12.
 * Event description: Event triggers for every change in plugin's attribute in Tiptap.

 * attribute - Type: string. Desc: attribute name
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: Content_id
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * is_tiptap - Type: bool. Desc: Indicate whether the event triggered from tiptap
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * value - Type: string. Desc: action value
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginAttributesChangedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginAttributesChanged = function (params) {
    return { evid: 12, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} openEditorSuccessParams
* @property {string} container - consumer name
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - external content id (based on usage)
* @property {string} editor_engine - draft/tiptap
* @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - (on refresh)
* @property {string} toolbarType - Formatting Toolbar is one of: ["sticky", "inline"]
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: open editor success. Evid: 9.
 * Event description: successfully opened rce.

 * container - Type: string. Desc: consumer name
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: external content id (based on usage)
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * is_tiptap - Type: bool. Desc: Indicate whether the event triggered from tiptap
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: (on refresh)
 *
 * toolbarType - Type: string. Desc: Formatting Toolbar is one of: ["sticky", "inline"]
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {openEditorSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openEditorSuccess = function (params) {
    return { evid: 9, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} uploadMediaTryParams
* @property {string} container - []
* @property {string} container_id - []
* @property {string} content_id - null
* @property {string} correlationId - to connect with success event
* @property {number} fileSize - []
* @property {string} mediaType - video/image/etc.
* @property {string} plugin_id - []
* @property {GUID} rce_session_id - []
* @property {string} type - not in use
* @property {string} version - rce versoin
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Upload media try. Evid: 13.
 * Event description: upload media in RCE started (per file) Not from media manager.

 * container - Type: string. Desc: []
 *
 * container_id - Type: string. Desc: []
 *
 * content_id - Type: string.
 *
 * correlationId - Type: string. Desc: to connect with success event
 *
 * fileSize - Type: numeric. Desc: []
 *
 * mediaType - Type: string. Desc: video/image/etc.
 *
 * plugin_id - Type: string. Desc: []
 *
 * rce_session_id - Type: guid. Desc: []
 *
 * type - Type: string. Desc: not in use
 *
 * version - Type: string. Desc: rce versoin
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {uploadMediaTryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var uploadMediaTry = function (params) {
    return { evid: 13, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginTableColumnRowActionParams
* @property {string} action - the action name
* @property {string} category - row/column
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugin Table Column/Row action. Evid: 32.
 * Event description: Each time the user make a change in the look of the table (change column/row order (drag and drop), change column width/ change row height.

 * action - Type: string. Desc: the action name
 *
 * category - Type: string. Desc: row/column
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginTableColumnRowActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginTableColumnRowAction = function (params) {
    return { evid: 32, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} tablePluginAddColumnRowParams
* @property {string} category - column/row
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} loaction - right/left/above/below
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - the post id from the consumer
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} source - 3 dot menu/ + sign
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: table plugin add column/row. Evid: 20.
 * Event description: each time column or row add to a table plug in.

 * category - Type: string. Desc: column/row
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * loaction - Type: string. Desc: right/left/above/below
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: the post id from the consumer
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * source - Type: string. Desc: 3 dot menu/ + sign
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {tablePluginAddColumnRowParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tablePluginAddColumnRow = function (params) {
    return { evid: 20, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} changePluginParams
* @property {string} button_name - the name of the button user clicked on
* @property {string} category - category of change (alignment/size/settings...)
* @property {string} container - blog/groups...
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} editor_engine - draft/tiptap
* @property {string} origin - toolbar/sidebar/ else
* @property {string} plugin_id - plugin
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
* @property {string} type - toolbar type (plugin toolbar/ format toolbar)
* @property {string} value - value changed to (center, right...)
* @property {string} version - version . of rce
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Click button in toolbar. Evid: 3.
 * Event description: user changed plugin setting (i.e user clicks button in toolbar that causes a change in plugin - including text).

 * button_name - Type: string. Desc: the name of the button user clicked on
 *
 * category - Type: string. Desc: category of change (alignment/size/settings...)
 *
 * container - Type: string. Desc: blog/groups...
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * origin - Type: string. Desc: toolbar/sidebar/ else
 *
 * plugin_id - Type: string. Desc: plugin
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * settingSessionId - Type: string. Desc: id of the setting session (each time the settings modal he will get a new one)
 *
 * type - Type: string. Desc: toolbar type (plugin toolbar/ format toolbar)
 *
 * value - Type: string. Desc: value changed to (center, right...)
 *
 * version - Type: string. Desc: version . of rce
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {changePluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var changePlugin = function (params) {
    return { evid: 3, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginToolbarLoadedParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} plugin_id - -
* @property {string} pluginName - -
* @property {string} post_id - post id
* @property {GUID} rce_session_id - null
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugin toolbar loaded. Evid: 48.
 * Event description: when a plugin toolbar is loaded in mobile apps.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * plugin_id - Type: string. Desc: -
 *
 * pluginName - Type: string. Desc: -
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid.
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginToolbarLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginToolbarLoaded = function (params) {
    return { evid: 48, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} inlineToolbarOpenedParams
* @property {string} container - consumer name
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - external content id (based on usage)
* @property {string} plugin_id - plugin from which the toolbar was opened
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - (on refresh)
* @property {string} toolbarType - plugin/formatting
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Inline toolbar opened. Evid: 46.
 * Event description: Inline toolbar opened (when user selects text).

 * container - Type: string. Desc: consumer name
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: external content id (based on usage)
 *
 * plugin_id - Type: string. Desc: plugin from which the toolbar was opened
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: (on refresh)
 *
 * toolbarType - Type: string. Desc: plugin/formatting
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {inlineToolbarOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var inlineToolbarOpened = function (params) {
    return { evid: 46, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} oaGetPostContentParams
* @property {string} container - blog/forum etc
* @property {string} container_id - id of group / forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} plugins_count - JSON containing {plugin_id: num of plugins}
* @property {string} plugins_details - JSON containing an array of dictionaries (each dictionary holds a plugin's details)
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - RCE version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: OA get post content. Evid: 7.
 * Event description: sent when consumer requests post content from RCE in OneApp.

 * container - Type: string. Desc: blog/forum etc
 *
 * container_id - Type: string. Desc: id of group / forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * plugins_count - Type: string. Desc: JSON containing {plugin_id: num of plugins}
 *
 * plugins_details - Type: string. Desc: JSON containing an array of dictionaries (each dictionary holds a plugin's details)
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: RCE version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {oaGetPostContentParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var oaGetPostContent = function (params) {
    return { evid: 7, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} addPluginStepParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} params - more details about the plugin
* @property {string} plugin_id - plugin id
* @property {string} plugin_specification - bookings/stores/events etc
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} step - []
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: add plugin step. Evid: 11.
 * Event description: Steps between clicking on the plugin and adding it on stage.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * params - Type: string. Desc: more details about the plugin
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugin_specification - Type: string. Desc: bookings/stores/events etc
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * step - Type: string. Desc: []
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {addPluginStepParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPluginStep = function (params) {
    return { evid: 11, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} clickConnectToDataRcePanelCmParams
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
**/
/**
 * Name: Click Connect to Data RCE Panel CM. Evid: 54.
 * Event description: user click on edit content inside the panel of RCE in Content Manager.

 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 * @param {clickConnectToDataRcePanelCmParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickConnectToDataRcePanelCm = function (params) {
    return { evid: 54, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} publishPostParams
* @property {string} container - blog/groups...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} editor_engine - draft/tiptap
* @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
* @property {string} params - more details about plugins { plugin_uniqe_id: details}
* @property {string} plugins_count - JSON containing {plugin_id: num of plugins}
* @property {string} plugins_details - JSON containing an array of dictionaries (each dictionary holds a plugin's details)
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Save Content Success. Evid: 5.
 * Event description: user published his post - currently Desktop only.

 * container - Type: string. Desc: blog/groups...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * is_tiptap - Type: bool. Desc: Indicate whether the event triggered from tiptap
 *
 * params - Type: string. Desc: more details about plugins { plugin_uniqe_id: details}
 *
 * plugins_count - Type: string. Desc: JSON containing {plugin_id: num of plugins}
 *
 * plugins_details - Type: string. Desc: JSON containing an array of dictionaries (each dictionary holds a plugin's details)
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {publishPostParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var publishPost = function (params) {
    return { evid: 5, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} openEditorParams
* @property {string} container - gorups/blog..
* @property {string} container_id - gorup_id..
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - []
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: open editor click. Evid: 10.
 * Event description: user/UoU opened the rc editor.

 * container - Type: string. Desc: gorups/blog..
 *
 * container_id - Type: string. Desc: gorup_id..
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: []
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {openEditorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openEditor = function (params) {
    return { evid: 10, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginViewedParams
* @property {string} container - consumer name
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - external content id (based on usage)
* @property {string} menu - more, + side menu
* @property {string} plugin_viewed - name of the plugin
* @property {GUID} rce_session_id - (on refresh)
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugin viewed. Evid: 18.
 * Event description: A plugin was viewed by the user in the editor menu.

 * container - Type: string. Desc: consumer name
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: external content id (based on usage)
 *
 * menu - Type: string. Desc: more, + side menu
 *
 * plugin_viewed - Type: string. Desc: name of the plugin
 *
 * rce_session_id - Type: guid. Desc: (on refresh)
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginViewedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginViewed = function (params) {
    return { evid: 18, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} resetToOriginalDesignParams
* @property {string} category - the main category of the change
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
**/
/**
 * Name: Reset To Original Design. Evid: 42.
 * Event description: user click on reset all design param to the original params
 in the editor.

 * category - Type: string. Desc: the main category of the change
 *
 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 * @param {resetToOriginalDesignParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var resetToOriginalDesign = function (params) {
    return { evid: 42, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} contentAddedParams
* @property {string} contact_id - external content id (based on usage)
* @property {string} container - consumer name
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_type - .
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {number} editing_time - in seconds
* @property {string} editor_engine - draft/tiptap
* @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
* @property {number} paragraph_count - .
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - (on refresh)
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
* @property {number} word_count - .
**/
/**
 * Name: Content added. Evid: 16.
 * Event description: An event for adding any content.

 * contact_id - Type: string. Desc: external content id (based on usage)
 *
 * container - Type: string. Desc: consumer name
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_type - Type: string. Desc: .
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editing_time - Type: numeric. Desc: in seconds
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * is_tiptap - Type: bool. Desc: Indicate whether the event triggered from tiptap
 *
 * paragraph_count - Type: numeric. Desc: .
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: (on refresh)
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 *
 * word_count - Type: numeric. Desc: .
 * @param {contentAddedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var contentAdded = function (params) {
    return { evid: 16, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} editDesignRceParams
* @property {string} category - the main category of the change
* @property {string} component_id - unique id of the component
* @property {string} content_id - null
* @property {string} subcategory - the sub category of the change
* @property {string} value - the value has change
**/
/**
 * Name: Edit Design RCE. Evid: 41.
 * Event description: user edit the design inside the panel of RCE in the editor.

 * category - Type: string. Desc: the main category of the change
 *
 * component_id - Type: string. Desc: unique id of the component
 *
 * content_id - Type: string.
 *
 * subcategory - Type: string. Desc: the sub category of the change
 *
 * value - Type: string. Desc: the value has change
 * @param {editDesignRceParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var editDesignRce = function (params) {
    return { evid: 41, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} deletePluginParams
* @property {string} container - blog/...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} editor_engine - draft/tiptap
* @property {string} plugin_id - []
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: delete plugin click. Evid: 4.
 * Event description: user deleted a plugin.

 * container - Type: string. Desc: blog/...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * plugin_id - Type: string. Desc: []
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {deletePluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var deletePlugin = function (params) {
    return { evid: 4, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} tablePluginClickOnEditButtonsParams
* @property {string} actionName - text style/vertical alignment / background color / border color
* @property {string} category - table/column/row
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} params - table style
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - the post id from the consumer
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: table plugin click on edit buttons. Evid: 24.
 * Event description: arrived each time user click on edit buttons.

 * actionName - Type: string. Desc: text style/vertical alignment / background color / border color
 *
 * category - Type: string. Desc: table/column/row
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * params - Type: string. Desc: table style
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: the post id from the consumer
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {tablePluginClickOnEditButtonsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tablePluginClickOnEditButtons = function (params) {
    return { evid: 24, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} pluginModalOpenedParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} editor_engine - draft/tiptap
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
* @property {string} plugin_id - plugin id
* @property {string} plugin_specification - bookings/stores/events etc
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Plugin Modal Opened. Evid: 33.
 * Event description: after click on plugin icon this event indicate that the modal is opened.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * is_tiptap - Type: bool. Desc: Indicate whether the event triggered from tiptap
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugin_specification - Type: string. Desc: bookings/stores/events etc
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {pluginModalOpenedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var pluginModalOpened = function (params) {
    return { evid: 33, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} viewerActionParams
* @property {string} action_name - image_link/expand_image etc.
* @property {string} container - groups/blog etc
* @property {string} container_id - app_def_id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} params - more details about plugins
* @property {string} plugin_id - []
* @property {string} plugin_specification - bookings/stores/events
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - null
* @property {string} post_id - null
* @property {string} productType - Product Specification (e.g. type of vertical embed)
* @property {string} value - additional information
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: viewer action. Evid: 8.
 * Event description: UoU did some action in the RCE viewer.

 * action_name - Type: string. Desc: image_link/expand_image etc.
 *
 * container - Type: string. Desc: groups/blog etc
 *
 * container_id - Type: string. Desc: app_def_id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * params - Type: string. Desc: more details about plugins
 *
 * plugin_id - Type: string. Desc: []
 *
 * plugin_specification - Type: string. Desc: bookings/stores/events
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string.
 *
 * post_id - Type: string.
 *
 * productType - Type: string. Desc: Product Specification (e.g. type of vertical embed)
 *
 * value - Type: string. Desc: additional information
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {viewerActionParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewerAction = function (params) {
    return { evid: 8, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} tablePluginClickOnOptionMenuParams
* @property {string} category - table/column/row
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} plugin_id - plugin id
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - the post id from the consumer
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: table plugin click on option menu. Evid: 22.
 * Event description: arrived each time user click on 3 dots menu.

 * category - Type: string. Desc: table/column/row
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: the post id from the consumer
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {tablePluginClickOnOptionMenuParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tablePluginClickOnOptionMenu = function (params) {
    return { evid: 22, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} settingsModalOpenedForPluginParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} settingSessionId - id of the setting session (each time the settings modal he will get a new one)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Settings modal opened for plugin. Evid: 36.
 * Event description: each time the user opened the settings modal for plugin.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * settingSessionId - Type: string. Desc: id of the setting session (each time the settings modal he will get a new one)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {settingsModalOpenedForPluginParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var settingsModalOpenedForPlugin = function (params) {
    return { evid: 36, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} mobilePluginsActionSheetClickParams
* @property {string} buttonName - button clicked
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - -
* @property {string} plugin_id - -
* @property {string} pluginName - -
* @property {string} post_id - post id
* @property {GUID} rce_session_id - -
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Mobile Plugins Action Sheet Click. Evid: 49.
 * Event description: when an action button is clicked in a plugins action sheet in mobile app.

 * buttonName - Type: string. Desc: button clicked
 *
 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: -
 *
 * plugin_id - Type: string. Desc: -
 *
 * pluginName - Type: string. Desc: -
 *
 * post_id - Type: string. Desc: post id
 *
 * rce_session_id - Type: guid. Desc: -
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {mobilePluginsActionSheetClickParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var mobilePluginsActionSheetClick = function (params) {
    return { evid: 49, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} viewerLoadedParams
* @property {string} container - consumer name
* @property {string} container_id - consumer app def id
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - external content id (based on usage)
* @property {string} pluginsCount - JSON containing {plugin_id: num of plugins}
* @property {string} post_id - post_id
* @property {string} postURL - post url
* @property {boolean} preview - preview=true/full=false
* @property {GUID} rce_session_id - (on refresh)
* @property {string} version - rce version
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Viewer Loaded. Evid: 15.
 * Event description: RCV is loaded.

 * container - Type: string. Desc: consumer name
 *
 * container_id - Type: string. Desc: consumer app def id
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: external content id (based on usage)
 *
 * pluginsCount - Type: string. Desc: JSON containing {plugin_id: num of plugins}
 *
 * post_id - Type: string. Desc: post_id
 *
 * postURL - Type: string. Desc: post url
 *
 * preview - Type: bool. Desc: preview=true/full=false
 *
 * rce_session_id - Type: guid. Desc: (on refresh)
 *
 * version - Type: string. Desc: rce version
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {viewerLoadedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var viewerLoaded = function (params) {
    return { evid: 15, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} audioPluginDetailsParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - Unique ID for content
* @property {string} creator - Audio file creator
* @property {Url} url - url (applicable for embed)
* @property {string} params - params will arrive according to the plugin
* @property {string} plugin_id - plugin id
* @property {string} pluginUniqueId - unique id for each plug in
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} title - Audio file title
* @property {string} track_duration - Track duration
* @property {string} type - File / Spotify / SoundCloud
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - null
**/
/**
 * Name: Media Plugins Details. Evid: 55.
 * Event description: Details for audio plugin.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: Unique ID for content
 *
 * creator - Type: string. Desc: Audio file creator
 *
 * url - Type: url. Desc: url (applicable for embed)
 *
 * params - Type: string. Desc: params will arrive according to the plugin
 *
 * plugin_id - Type: string. Desc: plugin id
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * title - Type: string. Desc: Audio file title
 *
 * track_duration - Type: string. Desc: Track duration
 *
 * type - Type: string. Desc: File / Spotify / SoundCloud
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string.
 * @param {audioPluginDetailsParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var audioPluginDetails = function (params) {
    return { evid: 55, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} addPluginSuccessParams
* @property {string} container - blog/forum/groups...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - null
* @property {string} editor_engine - draft/tiptap
* @property {string} entry_point - side_toolbar,footer_toolbar
* @property {string} entry_type - specification for the entry point
* @property {boolean} is_tiptap - Indicate whether the event triggered from tiptap
* @property {string} mediaOrigin - Upload/MediaCenter
* @property {string} params - more details about the plugin
* @property {string} plugin_id - plugin_id
* @property {string} plugin_specification - bookings/stores/events etc
* @property {string} pluginUniqueId - unique id for each plug in
* @property {string} plugins_details - specification of the plugin
* @property {string} post_id - post_id
* @property {GUID} rce_session_id - ID of the RCE session (each time a user opens the editor)
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: add plugin success. Evid: 6.
 * Event description: add plugin successfully.

 * container - Type: string. Desc: blog/forum/groups...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string.
 *
 * editor_engine - Type: string. Desc: draft/tiptap
 *
 * entry_point - Type: string. Desc: side_toolbar,footer_toolbar
 *
 * entry_type - Type: string. Desc: specification for the entry point
 *
 * is_tiptap - Type: bool. Desc: Indicate whether the event triggered from tiptap
 *
 * mediaOrigin - Type: string. Desc: Upload/MediaCenter
 *
 * params - Type: string. Desc: more details about the plugin
 *
 * plugin_id - Type: string. Desc: plugin_id
 *
 * plugin_specification - Type: string. Desc: bookings/stores/events etc
 *
 * pluginUniqueId - Type: string. Desc: unique id for each plug in
 *
 * plugins_details - Type: string. Desc: specification of the plugin
 *
 * post_id - Type: string. Desc: post_id
 *
 * rce_session_id - Type: guid. Desc: ID of the RCE session (each time a user opens the editor)
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {addPluginSuccessParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var addPluginSuccess = function (params) {
    return { evid: 6, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} uploadMediaFinishedParams
* @property {string} container - []
* @property {string} container_id - []
* @property {string} content_id - null
* @property {string} correlationId - to connect with success event
* @property {number} duration - in ms
* @property {string} errorReason - []
* @property {number} fileSize - []
* @property {boolean} isSuccess - []
* @property {string} mediaType - video/image/etc.
* @property {string} plugin_id - []
* @property {GUID} rce_session_id - []
* @property {string} type - not in use
* @property {string} version - rce versoin
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Upload media finished. Evid: 14.
 * Event description: upload media in RCE finished (per file) Not from media manager.

 * container - Type: string. Desc: []
 *
 * container_id - Type: string. Desc: []
 *
 * content_id - Type: string.
 *
 * correlationId - Type: string. Desc: to connect with success event
 *
 * duration - Type: numeric. Desc: in ms
 *
 * errorReason - Type: string. Desc: []
 *
 * fileSize - Type: numeric. Desc: []
 *
 * isSuccess - Type: bool. Desc: []
 *
 * mediaType - Type: string. Desc: video/image/etc.
 *
 * plugin_id - Type: string. Desc: []
 *
 * rce_session_id - Type: guid. Desc: []
 *
 * type - Type: string. Desc: not in use
 *
 * version - Type: string. Desc: rce versoin
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {uploadMediaFinishedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var uploadMediaFinished = function (params) {
    return { evid: 14, src: 116, endpoint: 'rich-editor', params: params };
};
/**
* @typedef {Object} tiptapFailureMonitoringParams
* @property {string} container - blog/groups/forum etc...
* @property {string} container_id - id of group/ forum etc
* @property {string} container_platform - Livesite / BM / OneApp
* @property {string} container_usage - Post / Feed / Comment
* @property {string} content_id - Unique id for each content
* @property {string} engine - Tiptap / draft
* @property {string} error_stack - error stack
* @property {GUID} rce_session_id - null
* @property {string} version - version of RCE
* @property {string} wixRicosVersion - identify of the wix-ricos version that consumers use
**/
/**
 * Name: Tiptap Failure Monitoring. Evid: 53.
 * Event description: Monitor Tiptap failures on mobile editor.

 * container - Type: string. Desc: blog/groups/forum etc...
 *
 * container_id - Type: string. Desc: id of group/ forum etc
 *
 * container_platform - Type: string. Desc: Livesite / BM / OneApp
 *
 * container_usage - Type: string. Desc: Post / Feed / Comment
 *
 * content_id - Type: string. Desc: Unique id for each content
 *
 * engine - Type: string. Desc: Tiptap / draft
 *
 * error_stack - Type: string. Desc: error stack
 *
 * rce_session_id - Type: guid.
 *
 * version - Type: string. Desc: version of RCE
 *
 * wixRicosVersion - Type: string. Desc: identify of the wix-ricos version that consumers use
 * @param {tiptapFailureMonitoringParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var tiptapFailureMonitoring = function (params) {
    return { evid: 53, src: 116, endpoint: 'rich-editor', params: params };
};
//# sourceMappingURL=index.js.map